// TODO: We should name this something more specific
const sanitizeInput = input => {
  // eslint-disable-next-line no-control-regex
  const regex = /[^\u0000-\u00ff]/
  let sanitizedString = input.replace(regex, ' ')

  while (regex.test(sanitizedString)) {
    sanitizedString = sanitizedString.replace(regex, ' ')
  }
  return sanitizedString
}

const sanitizeSubdomainXSS = input => input.replace(/[^\w.\-]/gi, c => `&#${  c.charCodeAt(0)  };`)

export { sanitizeInput, sanitizeSubdomainXSS }
